import Api from "~/service/Api";

class GroupCustomersRepository {
  fetchGroupCustomers() {
    return Api.get("/group-customers");
  }
}

export default GroupCustomersRepository;
